import * as React from 'react';
import { Translations } from '../translations.interface';

type CategoryProps = {
  category: string;
  translations: Translations['categories'];
  setCategory: (name: string) => void;
};

export const Category = (props: CategoryProps): JSX.Element => (
  <div className="e-field" variable-editor-form-field="category">
    <label className="e-field__label">{props.translations.title}</label>
    <e-select>
      <select className="e-select" onChange={event => props.setCategory(event.target.value)} value={props.category}>
        <option value="uncategorized">{props.translations.placeholder}</option>
        <option value="account">{props.translations.account}</option>
        <option value="background">{props.translations.background}</option>
        <option value="backgroundImage">{props.translations.backgroundImage} </option>
        <option value="bodyCopy">{props.translations.bodyCopy}</option>
        <option value="buttonCta">{props.translations.buttonCta}</option>
        <option value="content">{props.translations.content}</option>
        <option value="darkMode">{props.translations.darkMode}</option>
        <option value="dialog">{props.translations.dialog}</option>
        <option value="headline">{props.translations.headline}</option>
        <option value="image">{props.translations.image}</option>
        <option value="logo">{props.translations.logo}</option>
        <option value="navigationMenu">{props.translations.navigationMenu}</option>
        <option value="paddingSpacing">{props.translations.paddingSpacing}</option>
        <option value="price">{props.translations.price}</option>
        <option value="ribbon">{props.translations.ribbon}</option>
      </select>
    </e-select>
  </div>
);
